<template>
<div>
    <p class="list-badge" v-if="materialData && materialData.isPackage">
      <span class="badge">{{$t('INDENT_WEIGHT')}}</span>
      <label>
        <template
          v-if="materialData.weight"
        >{{fixTwoDigits(materialData.weight.value)}} {{materialData.weight.unit}}</template>
        <template v-else>0</template>
      </label>
      <span class="badge">{{$t('INDENT_VOLUME')}}</span>
      <label>
        <template
          v-if="materialData.volume"
        >{{fixTwoDigits(materialData.volume.value)}} {{materialData.volume.unit}}</template>
        <template v-else>0</template>
      </label>
      <span class="badge">{{$t('INDENT_QUANTITY')}}</span>
      <label>
        <template v-if="materialData.quantity">
          <span v-if="materialData.quantity.value">
            {{fixTwoDigits(
            materialData.quantity.value
            )}}
            {{materialData.quantity.unit}}
          </span>
        </template>
        <template v-else>0</template>
      </label>
    </p>
    <div class="position-relative sdlc-material-table" :class="getTableClass">
      <div class="action-fixed-table">
        <a href="javascript:;" @click="handlePrev" class="slide-leftarrow">
          <i class="arrow left pointer"></i>
        </a>
        <a href="javascript:;" @click="handleNext" class="slide-rightarrow" :class="!isEpodVisible && 'full-width-arrow'">
          <i class="arrow right pointer"></i>
        </a>
      </div>
      <Table
        highlight-current-row
        :data="materialDataFormatted"
        @cell-click="currentCell"
        max-height="244"
        ref="tableref"
        stripe
        border
        row-key="id"
        lazy
        :load="load"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        @header-dragend="getDepotDetailParameters"
        editable="right"
        class="table-fixed expand-icon"
        aria-describedby="materialDetailsDataFormated"
        >
        <Table-column
          fixed
          :resizable="false"
          label="Material Unique Number"
          width="145">
          <template slot-scope="material">
            <div class="left-value">
              <span>
                <Ellipsis v-bind:text="material.row.material_ref_id" :length="10" />
              </span>
              <epod-comment
                v-if="isEpodVisible"
                :isEpodVisible="isEpodVisible"
                :comment="material.row.epod.comment"
                :material="material.row"
                :orderNumber="orderNo"
                @update-comment="updateComment"
              >
              </epod-comment>
            </div>
          </template>
        </Table-column>
        <Table-column
          :fixed="column.fixed"
          v-for="column in computedSlidableColumns"
          :prop="column.column"
          :label="column.tlabel ? $t(column.tlabel) : column.label"
          :key="column.label"
          columnKey="tableref"
          :width="getWidth('tableref',column.column) ? getWidth('tableref',column.column) : column.w">
            <template slot-scope="scope">
              <span v-if="column.label==='Invoice Number'&&scope.row&&scope.row.invoice&&scope.row.invoice.otp_status===materialInvoiceOtpStatus.GENERATED">
                <Tooltip class="item" effect="dark"
                  :content="`OTP - ${scope.row.invoice.otp_number}: Pending`"
                  placement="bottom">
                  <svgicon name="exclamation" class="text-red"
                    width="10" height="10" />
                </Tooltip>
                <Ellipsis v-bind:text="scope.row.invoice_number" :length="10" />
              </span>
              <span v-else-if="column.label==='Invoice Number'&&scope.row&&scope.row.invoice&&scope.row.invoice.otp_status===materialInvoiceOtpStatus.APPROVED"
                class="cell-icon text-green-medium">
                <Tooltip class="item" effect="dark"
                  :content="`OTP - ${scope.row.invoice.otp_number}: Submitted`"
                  placement="bottom">
                  <svgicon name="icon-tick-sm" class="pointer" width="10" height="10"/>
                </Tooltip>
                <Ellipsis v-bind:text="scope.row.invoice_number" :length="10" />
              </span>
              <span v-else-if="column.label==='Collection Amount'">
                <Tooltip v-if="scope.row.invoice.collection_amount" popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                  <div slot="content">{{scope.row.invoice.collection_amount}}</div>
                  <div class="text-ellipsis pointer">{{scope.row.invoice.collection_amount}}</div>
                </Tooltip>
              <span v-else>-</span>
              </span>
              <span v-else-if="column.ellipsis">
                <Tooltip popper-class="max-width" :open-delay="200" effect="dark" placement="bottom-start">
                  <div slot="content">{{scope.row[column.column]}}</div>
                  <div class="text-ellipsis pointer">{{scope.row[column.column]}}</div>
                </Tooltip>

                <!-- <Ellipsis v-bind:text="scope.row[column.column]" :length="10" /> -->
              </span>
              <span v-else>{{scope.row[column.column]}} </span>
            </template>
        </Table-column>
        <Table-column
          :fixed="column.fixed"
          v-for="column in materialCustomColumn"
          :prop="column.column"
          :label="column.tlabel ? $t(column.tlabel) : column.label"
          :key="column.label"
          columnKey="tableref"
          :width="getWidth('tableref',column.column) ? getWidth('tableref',column.column) : column.w">
          <template slot="header" slot-scope="scope">
            <span :class="{'text-wrapvertical':index === 0}">{{column.tlabel ? $t(column.tlabel) : column.label}}</span>
          </template>
          <template  slot-scope="scope">
                <span>{{scope.row['custom_fields'] && scope.row['custom_fields'][column.column] || '-'}} </span>
          </template>
        </Table-column>
        <Table-column
          fixed="right"
          :resizable="false"
          v-for="(column,index) in fixedColumnsVisible"
          :class="column.class"
          :key="index"
          :label="column.tlabel ? $t(column.tlabel) : column.label"
          :width="column.w"
          v-if="column.visible">
          <template slot="header" slot-scope="scope">
            <span :class="{'text-wrapvertical':index === 0}">{{column.tlabel ? $t(column.tlabel) : column.label}}</span>
          </template>
          <template slot-scope="scope">
            <table-cell
              :readOnly="
              !isEpodEditable ||
              column.readonly ||
              (scope.row.packages && scope.row.packages.length > 0 &&
              canShortageDamageEditable(scope.row.packages[0].id))"
              :isFirstColumn="(index === 0)"
              :index="scope.$index"
              :header="column"
              :movement="movement"
              :details="scope.row.epod"
              :material="scope.row.material"
              :pce_box="scope.row.piece_per_box"
              :volume_per_piece="scope.row.volume_per_piece"
              :quantity="scope.row.quantity"
              :weight="scope.row.weight"
              :materialId="scope.row.id"
              :originalMaterialSummary="originalMaterialSummaries[scope.row.id]"
              :mrp="scope.row.mrp"
              :materialCategory="scope.row.material_category"
              @markAsModified="markAsModified"/>
          </template>
        </Table-column>
        <Table-column v-if="canShowReturnMaterials"
          :resizable="false"
          fixed="right"
          :width="105"
          :label="$t('RETURN_MATERIAL')"
          class="w100"
        >
          <template slot="header" slot-scope="scope">
            <span :class="{'pl-25': fixedColumnsVisible.length === 0}">{{ $t('RETURN_MATERIAL') }}</span>
          </template>
          <template slot-scope="scope">
            <return-materials
              :material="scope.row"
              :is-first-column="fixedColumnsVisible.length === 0"
              :unsaved-return-material-details="unsavedReturnMaterialDetails"
              @update-return-count="updateReturnMaterialCount"
            />
          </template>
        </Table-column>
        <Table-column
          v-if="showSdlcColumn"
          :width="30"
          class-name="sdlc-col"
          fixed="right">
          <template slot-scope="material">
            <div class="sdlc-cell">
              <svgicon name="icon-edit" class="icon-md pointer" width="11" height="11" @click.stop="openSdlcCategorization(material.row)"/>
            </div>
          </template>
        </Table-column>
      </Table>
    </div>
  </div>
</template>
<script>
import { materialInvoiceOtpStatus, VolumeUnits } from 'pando-constants';
import { mapGetters } from 'vuex';

import TableCell from './TableCell';
import EpodComment from './epod-comment';
import debounce from 'debounce';
import TableColMixin from '@common/mixins/TableColMixin';
import ReturnMaterials from '../../../../../../../common-v2/components/ReturnMaterials.vue';
import VolumeFormulaConvertor from '../../../../../../../common-v2/helpers/volume-formula-converter';

export default {
  name: 'materialsDivision',
  mixins: [TableColMixin],
  props: {
    editedPackageDetails: {
      type: Object,
      default: () => {},
    },
    materialData: {
      type: Object,
      default: () => {},
    },
    fixedColumns: {
      type: Array,
      default: () => [],
    },
    slidableColumns: {
      type: Array,
      default: () => [],
    },
    modifiedMaterials: {
      type: Set,
      default: () => new Set(),
    },
    isEpodVisible: {
      type: Boolean,
      default: true,
    },
    isEpodEditable: {
      type: Boolean,
      defaut: false,
    },
    previousData: {
      type: Array,
      default: () => [],
    },
    movement: {
      type: Number,
    },
    orderNo: {
      type: String,
    },
    originalMaterialSummaries: {
      type: Object,
      default: () => {},
    },
    canShowReturnMaterials: {
      type: Boolean,
      default: () => false,
    },
    materialCustomColumn: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      materialInvoiceOtpStatus,
    };
  },
  computed: {
    ...mapGetters({
      unsavedReturnMaterialDetails: 'indents/returnMaterialDetails',
    }),
    materialDataFormatted() {
      return this.materialData.materials && this.getMaterials(this.materialData.materials);
    },
    fixedColumnsVisible() {
      return this.isEpodVisible ? this.fixedColumns.filter((column) => {
        if (column.name === 'carton_damage') {
          return !this.materialData.isPackage;
        }
        return column.visible;
      }) : [];
    },
    getTableClass() {
      return this.fixedColumnsVisible.length ? 'column-3' : 'column-0';
    },
    getWidth() {
      return (tableKey, columnKey) => (this.tableColWidth[tableKey] ? (this.tableColWidth[tableKey][columnKey] ? this.tableColWidth[tableKey][columnKey] : false) : false);
    },
    preferredVolumeUnit() {
      return this.$preferredVolumeUnit();
    },
    computedSlidableColumns() {
      let updatedColumns;
      if (this.preferredVolumeUnit !== VolumeUnits.CFT) {
        updatedColumns = this.slidableColumns.map((column) => {
          const updatedColumnValue = { ...column };
          if (column.column === 'volume_value') {
            updatedColumnValue.label = `Volume (${this.preferredVolumeUnit})`;
            updatedColumnValue.tlabel = `INDENT_VOLUME_${this.preferredVolumeUnit}`;
          }
          return updatedColumnValue;
        });
      }
      return updatedColumns || this.slidableColumns;
    },
    showSdlcColumn() {
      return this.$hasFeature('sdlc_categorization');
    },
  },
  created() {
    this.setColumnWidth();

    // eslint-disable-next-line no-unused-expressions
    this.materialData && this.materialData.materials.forEach((element) => {
      this.previousData.push(JSON.parse(JSON.stringify(element.epod)));
    });
  },
  methods: {
    openSdlcCategorization(material) {
      this.$emit('open-sdlc-categorization', {
        material,
        orderNo: this.orderNo,
      });
    },
    canShortageDamageEditable(packageId) {
      if (this.editedPackageDetails[packageId] &&
      (this.editedPackageDetails[packageId].is_package_shortage ||
      this.editedPackageDetails[packageId].is_package_damaged)
      ) {
        return true;
      }
      return this.materialData.is_package_damaged || this.materialData.is_package_shortage;
    },
    updateReturnMaterialCount(data) {
      const returnMaterials = { ...this.unsavedReturnMaterialDetails };
      if (Number(data.returnCount) === 0) {
        delete returnMaterials[data.materialId];
      } else {
        returnMaterials[data.materialId] = data.returnCount;
      }
      this.$store.commit('indents/setReturnMaterialDetails', returnMaterials);
    },
    getMaterials(materials) {
      return materials.map((material) => {
        const prevQuantityValue = (material.previous_quantity &&
          material.previous_quantity.value) || (material.quantity &&
          material.quantity.value) || 0;
        return {
          ...material,
          quantity_text: `${material.quantity && this.fixTwoDigits(material.quantity.value)} (${material.quantity && material.quantity.unit})`,
          prev_leg_quantity_text: `${this.fixTwoDigits(prevQuantityValue)} (${material.quantity && material.quantity.unit})`,
          material_code: material.material && material.material.code,
          material_name: material.material && material.material.name,
          weight_value: material.weight && this.fixTwoDigits(material.weight.value),
          volume_value: material.volume && this.fixTwoDigits(this.getConvertedClientVolume(material.volume.value)),
          custom_field_1: material.material && material.material.custom_field_1,
          custom_field_2: material.material && material.material.custom_field_2,
          invoice_number: material.invoice && material.invoice.number,
        };
      });
    },
    load(material, treeNode, resolve) {
      setTimeout(() => {
        resolve(this.getMaterials(material.children));
      }, 1000);
    },
    getDepotDetailParameters(newWidth, oldWidth, column) {
      const modifiedColumn = { ...column };
      modifiedColumn.label = modifiedColumn.property;
      this.setTableParameters(column.columnKey, newWidth, modifiedColumn);
    },
    markAsModified(materialId) {
      this.$emit('markAsModified', materialId);
    },
    updateComment(data) {
      this.$emit('updateComment', data);
    },
    /**
     * table methods only for highlight row
     */
    currentCell(row, column, cellClick, event) {
      // handle sdlc column click
      if (column.className && column.className.includes('sdlc-col')) {
        this.openSdlcCategorization(row);
        return;
      }
      // adding the cell highlight only for right fixed table
      if (column.fixed === 'right') {
        const prevElement = this.$el.getElementsByClassName('cell-highlight')[0];
        if (prevElement != undefined || prevElement != null) {
          prevElement.classList.remove('cell-highlight');
          prevElement.classList.remove('first-cell');
        }
        if (column.label === this.fixedColumns[0].label) {
          cellClick.classList.add('first-cell');
        }
        cellClick.classList.add('cell-highlight');
        this.topCellClass('cellBorder', cellClick);
      }
    },
    topCellClass(cssName, cell) {
      const firstRow = cell.parentNode.parentNode.firstChild;
      const topCell = firstRow.cells[cell.cellIndex];
      this.removeClassByName('cellBorder');
      topCell.classList.add('cellBorder');
    },
    removeClassByName(cssName) {
      const array = this.$el.getElementsByClassName(cssName);
      for (let i = 0; i < array.length; i += 1) {
        array[i].classList.remove(cssName);
      }
    },
    handlePrev() {
      this.sideScroll('left', 20, 200, 200);
    },
    handleNext() {
      this.sideScroll('right', 20, 200, 200);
    },
    sideScroll: debounce(function debounceScroll(direction, speed, distance, step) {
      let element = this.$refs.tableref.bodyWrapper;
      if (!element) {
        element = this.$refs.tableref[0].bodyWrapper;
      }
      if (direction === 'reset') {
        element.scrollLeft = 0;
      } else if (direction === 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
    }, 20),
    fixTwoDigits(val) {
      const value = val || 0;
      return parseFloat(value.toFixed(2));
    },
    getConvertedClientVolume(volume) {
      const volumeInClientUnit = new VolumeFormulaConvertor().revertToClient(this.preferredVolumeUnit, volume);
      return volumeInClientUnit;
    },
  },
  components: {
    TableCell,
    EpodComment,
    ReturnMaterials,
  },
};
</script>

<style scoped>
.sdlc-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
    line-height: 22px;
    cursor: pointer;
    vertical-align: middle;
    color: #376F99;
}
</style>
<style>
.sdlc-material-table .el-table--border .sdlc-col.el-table__cell {
  border-left: none !important;
  border-right: none !important;
}
.sdlc-material-table .el-table--border .sdlc-col.el-table__cell .cell {
  padding: 0 !important;
}
.sdlc-material-table .el-table__fixed-right td.el-table__cell:nth-last-child(2),
.sdlc-material-table .el-table__fixed-right th.el-table__cell:nth-last-child(2),
.sdlc-material-table .el-table__fixed-right th.el-table__cell:nth-last-child(3) {
  border-right: none !important;
}
/* Fix: Allow SDLC button clicks on selected rows */
.sdlc-material-table .el-table__body tr.current-row .sdlc-col.el-table__cell {
  pointer-events: auto !important;
}
</style>
